import { config } from "./config.js";
import Model from "./Model.js";

const model = new Model(config.imageMap);

document.addEventListener("alpine:init", () => {
	Alpine.store("controller", {
		imageMapSrc: { value: model.imageMap.src },
		imageMapItems: { value: model.imageMap.items },
	});
});
